module.exports = "page-container {\n  display: block; }\n"